<template>
  <card class="card-user">
    <img slot="image" class="mb-5" :src="cover_image" alt="..." />
    <div class="author">
      <a href="#">
        <img class="avatar border-gray" src="/img/faces/undraw_profile.svg" alt="..." />

        <h4 class="title">{{ name }}<br />
          <small>{{ email }}</small><br />
        </h4>
      </a>
      <p v-if="role !==''" class="text-secondary"><small>Type: {{ role }}</small></p>
    </div>
    <p class="description text-center"> "{{ outlet_name }}" <br>
      {{ outlet_address }}<br>
    </p>
    <div slot="footer" class="text-center d-flex justify-content-center">
      <button href="#" class="btn btn-simple"><i class="fa fa-facebook-square"></i></button>
      <button href="#" class="btn btn-simple"><i class="fa fa-twitter"></i></button>
      <button href="#" class="btn btn-simple"><i class="fa fa-google-plus-square"></i></button>
    </div>
  </card>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import { mapGetters } from 'vuex'
import axios from '@/axios'
export default {
  components: {
    Card
  },
  data() {
    return {
      roles: new Set(),
      cover_image: '',
      outletid: '',
      outlet: null,
      name: '',
      email: '',
      outlet_name: '',
      outlet_address: '',
      role: '',
    }
  },
  computed: {
    ...mapGetters(['user']),
    /* userName() {
      return this.user && this.user.name ? this.user.name : ''
    },
    userEmail() {
      return this.user && this.user.email ? this.user.email : ''
    }, */
  },
  created() {
    this.user.roles.forEach((r) => {
      this.roles.add(r.name);
    });
    this.user.outlet.forEach((outlet) => {
      if (outlet) {
        console.log('outlet', outlet);
        this.userHasOutlet = true;
        this.outlet = outlet;
        this.outletid = outlet.outletid;
        this.outlet_name = outlet.name;
        this.address = outlet.address;
      }

    });
    console.log('Role', ...this.roles);

    if (this.roles.has('superadmin')) {
      this.outlet_name = 'TOUCHPOINT';
      this.outlet_address = 'No. 2, 2nd Floor, 1st Cross, B. M. Kaval, New Baiyappanahalli Extn, Indiranagar, Bengalore';
    }
    this.getOutlet();
    this.getUser();
  },
  methods: {
    getClasses(index) {
      var remainder = index % 3
      if (remainder === 0) {
        return 'col-md-3 col-md-offset-1'
      } else if (remainder === 2) {
        return 'col-md-4'
      } else {
        return 'col-md-3'
      }
    },
    getOutlet() {
      if (this.roles.has('user')) {
        axios.post('outlet/getById', {
          outletid: this.outletid
        }).then((res) => {
          console.log('outlet response', res.data.data);
          let outlet = res.data.data;
          if (outlet.cover_image !== "") {
            this.cover_image = outlet.cover_image
          } else {
            this.cover_image = require('@/assets/images/cover/default.webp');
          }
        });
      } else {
        this.cover_image = require('@/assets/images/cover/default.webp');
      }
    },
    getUser() {
      axios.post('outlet/user/getById', {
        user_id: this.user.id
      }).then((res) => {
        let response = res.data.data;
        console.log('user res', response);
        if (response) {
          this.name = response.name;
          this.email = response.email;
          this.role = response.role.name.toUpperCase();
        }
      });
    },
  }
}

</script>
<style></style>
